import * as React from 'react';
import styled from 'styled-components';

const Article = styled.article`
	font-size: 1rem;

	@media (${(props) => props.theme.mediumUp}) {
		font-size: 1.125rem;
	}

	@media (${(props) => props.theme.largeUp}) {
		font-size: 1.375rem;
	}

	/* ie11 fix */
	@media all and (-ms-high-contrast: none) {
		flex-basis: auto;
	}
`;

const ArticleTextOnly = ({ children }) => (
	<Article className='text-only col-12 col-md-9'>{children}</Article>
);

export default ArticleTextOnly;
